/* Sparq Wear — şans çarkı, müşteri fotoğrafı penceresi, "Yorum yaz" butonu */
(() => {
  if (window.__sqwWheel) return;
  window.__sqwWheel = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const DAY = 24 * 60 * 60 * 1000;
  const store = {
    get(k) {
      try {
        return JSON.parse(localStorage.getItem(k) || 'null');
      } catch (e) {
        return null;
      }
    },
    set(k, v) {
      try {
        localStorage.setItem(k, JSON.stringify(v));
      } catch (e) {}
    },
  };
  const cookie = (name) => document.cookie.split('; ').find((c) => c.startsWith(name + '='));
  const setCookie = (name, val, ms) => {
    document.cookie = `${name}=${encodeURIComponent(val)}; max-age=${Math.floor(ms / 1000)}; path=/; SameSite=Lax`;
  };

  const anyModalOpen = () => !!document.querySelector('dialog[open]:not(.sqw-wheel)');

  /* ---------- Genel pencere kapatma ---------- */
  document.addEventListener('click', (e) => {
    const close = e.target.closest('[data-sqw-dialog-close]');
    if (close) close.closest('dialog').close();
    if (e.target.matches('dialog.sqw-photo, dialog.sqw-wheel')) e.target.close(); // arka plana tıklama
  });

  /* ---------- Müşteri fotoğrafı ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sqw-photo]');
    if (!b) return;
    const d = document.getElementById('sqw-photo-dialog');
    if (!d) return;
    const img = d.querySelector('[data-sqw-photo-img]');
    img.src = b.dataset.src;
    img.alt = b.querySelector('img') ? b.querySelector('img').alt : '';
    d.querySelector('[data-sqw-photo-stars]').style.setProperty('--sqw-rating', b.dataset.rating || 5);
    d.querySelector('[data-sqw-photo-text]').textContent = b.dataset.text || '';
    d.querySelector('[data-sqw-photo-author]').textContent = b.dataset.author || '';
    const a = d.querySelector('[data-sqw-photo-product]');
    a.textContent = b.dataset.product || '';
    a.href = b.dataset.url || '#';
    d.showModal();
  });

  /* ---------- Yorum yaz (Loox formu, fotoğraf yükleme dahil) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sqw-write-review]');
    if (!b) return;
    const id = b.dataset.productId;
    const L = window.LOOX;
    if (L && typeof L.showReviewForm === 'function') {
      try {
        L.showReviewForm(id);
        return;
      } catch (err) {}
    }
    const client = (L && L.clientId) || 'kzh4Dfvm2A';
    window.open(`https://loox.io/widget/${client}/write/${id}`, '_blank', 'noopener');
  });

  /* ---------- Şans çarkı ---------- */
  const wrap = document.querySelector('[data-sqw-wheel-root]');
  if (!wrap) return;
  const dialog = wrap.querySelector('#sqw-wheel');
  const codes = (wrap.dataset.codes || '').split(',');
  const labels = (wrap.dataset.labels || '').split('|');
  /* 8 dilim: hangi ödül (1–4) */
  const SLICES = [1, 2, 3, 1, 4, 2, 3, 2];
  /* Ödül olasılıkları (toplam 100): %5 → 40, %10 → 35, kargo → 20, %15 → 5 */
  const WEIGHTS = { 1: 40, 2: 35, 3: 20, 4: 5 };

  const won = () => {
    const w = store.get('sqwWheel');
    if (w && Date.now() - w.at < DAY) return w;
    if (cookie('sqw_wheel')) return { code: decodeURIComponent(cookie('sqw_wheel').split('=')[1] || ''), at: Date.now() };
    return null;
  };
  const dismissedToday = () => {
    const d = store.get('sqwWheelSeen');
    return d && Date.now() - d < DAY;
  };

  const applyCode = async (code) => {
    try {
      await fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
      return true;
    } catch (e) {
      return false;
    }
  };

  const showResult = (w) => {
    dialog.querySelector('[data-sqw-wheel-step="form"]').hidden = true;
    const r = dialog.querySelector('[data-sqw-wheel-step="result"]');
    r.hidden = false;
    r.querySelector('[data-sqw-wheel-prize]').textContent = w.label || '';
    r.querySelector('[data-sqw-wheel-code]').textContent = w.code;
    r.querySelector('[data-sqw-wheel-applied]').textContent = w.applied ? r.dataset.applied || 'Kod sepetine uygulandı; ödeme sayfasında indirimi göreceksin.' : '';
  };

  const updateCtas = () => {
    const w = won();
    const tab = wrap.querySelector('[data-sqw-wheel-tab]');
    if (tab) tab.hidden = !!w && !w.code;
    document.querySelectorAll('[data-sqw-wheel-cta]').forEach((cta) => {
      if (!w) return;
      const title = cta.querySelector('[data-sqw-wheel-cta-title]');
      const text = cta.querySelector('[data-sqw-wheel-cta-text]');
      if (title) title.textContent = (w.label || '') + ' · ' + w.code;
      if (text) text.textContent = 'Kodun sepetine uygulandı. Ödeme sayfasında görürsün.';
    });
  };

  const open = (auto) => {
    if (!dialog || dialog.open) return;
    if (auto && (won() || dismissedToday() || anyModalOpen())) return;
    const w = won();
    if (w) showResult(w);
    dialog.showModal();
    if (auto) store.set('sqwWheelSeen', Date.now());
  };

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sqw-wheel-open]');
    if (!b) return;
    e.preventDefault();
    const drawer = document.getElementById('cart-drawer');
    if (drawer && drawer.isOpen && typeof drawer.close === 'function') {
      drawer.__sqwSkipExit = true;
      drawer.close();
      setTimeout(() => open(false), 350);
    } else open(false);
  });
  dialog.addEventListener('close', () => store.set('sqwWheelSeen', Date.now()));

  /* Telefon: 5xx xxx xx xx */
  const phone = dialog.querySelector('[data-sqw-wheel-phone]');
  phone.addEventListener('input', () => {
    let d = phone.value.replace(/\D/g, '');
    if (d.startsWith('90')) d = d.slice(2);
    if (d.startsWith('0')) d = d.slice(1);
    d = d.slice(0, 10);
    phone.value = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 8), d.slice(8, 10)].filter(Boolean).join(' ');
  });

  const pick = () => {
    let r = Math.random() * 100;
    let prize = 1;
    for (const k of [1, 2, 3, 4]) {
      r -= WEIGHTS[k];
      if (r <= 0) {
        prize = k;
        break;
      }
    }
    const idx = SLICES.map((p, i) => (p === prize ? i : -1)).filter((i) => i >= 0);
    return { prize, slice: idx[Math.floor(Math.random() * idx.length)] };
  };

  const form = dialog.querySelector('form');
  const err = dialog.querySelector('[data-sqw-wheel-error]');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = form.querySelector('[data-sqw-wheel-email]').value.trim();
    const digits = phone.value.replace(/\D/g, '');
    const iys = form.querySelector('[data-sqw-wheel-iys]').checked;
    const kvkk = form.querySelector('[data-sqw-wheel-kvkk]').checked;
    let msg = '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) msg = 'Geçerli bir e-posta adresi yaz.';
    else if (!/^5\d{9}$/.test(digits)) msg = 'Telefonu 5 ile başlayan 10 hane olarak yaz (5xx xxx xx xx).';
    else if (!iys || !kvkk) msg = 'Çarkı çevirmek için iki onay kutusunu da işaretle.';
    if (msg) {
      err.textContent = msg;
      err.hidden = false;
      return;
    }
    err.hidden = true;
    if (won()) {
      showResult(won());
      return;
    }
    const btn = form.querySelector('[data-sqw-wheel-spin]');
    btn.disabled = true;

    const { prize, slice } = pick();
    const code = codes[prize - 1];
    const label = labels[prize - 1];

    /* Shopify müşteri kaydı: e-posta + pazarlama izni; telefon ve kazanılan kod etiket olarak */
    const tags = ['cark', 'cark-' + code.toLowerCase(), 'tel-90' + digits, 'ticari-ileti-onay', 'kaynak-cark'];
    form.querySelector('[data-sqw-wheel-tags]').value = tags.join(', ');
    const fd = new FormData(form);
    fetch(form.action, { method: 'POST', body: fd, credentials: 'same-origin' }).catch(() => {});

    /* Çevirme animasyonu: dilim sağdaki oka gelir */
    const rotor = dialog.querySelector('[data-sqw-wheel-rotor]');
    const jitter = Math.random() * 24 - 12;
    const turns = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 6;
    const deg = turns * 360 + ((360 - slice * 45) % 360) + jitter;
    rotor.style.transition = turns ? 'transform 4.6s cubic-bezier(0.17, 0.84, 0.25, 1)' : 'none';
    rotor.style.transform = `rotate(${deg}deg)`;

    const w = { code, label, at: Date.now(), applied: false };
    store.set('sqwWheel', w);
    setCookie('sqw_wheel', code, DAY);

    setTimeout(async () => {
      w.applied = await applyCode(code);
      store.set('sqwWheel', w);
      showResult(w);
      updateCtas();
      btn.disabled = false;
    }, turns ? 4800 : 200);
  });

  dialog.querySelector('[data-sqw-wheel-copy]').addEventListener('click', async (e) => {
    const code = dialog.querySelector('[data-sqw-wheel-code]').textContent;
    try {
      await navigator.clipboard.writeText(code);
      e.currentTarget.textContent = 'Kopyalandı';
    } catch (err) {}
  });
  dialog.querySelector('[data-sqw-wheel-go]').addEventListener('click', () => {
    dialog.close();
    if (window.SparqCart && window.SparqCart.open()) return;
    window.location.href = root + 'collections/all';
  });

  /* Tetikleyiciler */
  const tab = wrap.querySelector('[data-sqw-wheel-tab]');
  if (tab) tab.hidden = false;
  updateCtas();
  new MutationObserver(updateCtas).observe(document.body, { childList: true, subtree: true });

  // 1) Ürün sayfasında belirli süre (varsayılan 60 sn) inceledikten sonra
  if (wrap.dataset.template === 'product') {
    setTimeout(() => {
      if (document.visibilityState === 'visible') open(true);
    }, Number(wrap.dataset.delay || 60) * 1000);
  }

  // 2) Sepeti ödeme yapmadan kapatınca (sepette ürün varken)
  let leavingToCheckout = false;
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-sqw-cart-card], [data-sqw-cart-cod], [name="checkout"], a[href*="/checkout"]')) leavingToCheckout = true;
  });
  const hookDrawer = () => {
    const drawer = document.getElementById('cart-drawer');
    const d = drawer && drawer.querySelector('dialog');
    if (!d || d.__sqwHooked) return;
    d.__sqwHooked = true;
    d.addEventListener('close', () => {
      if (drawer.__sqwSkipExit) {
        drawer.__sqwSkipExit = false;
        return;
      }
      if (leavingToCheckout) return;
      const count = Number((document.querySelector('.cart-bubble__text, [data-cart-count]') || {}).textContent || 0);
      const hasItems = count > 0 || !!document.querySelector('#cart-drawer .cart-items__table, #cart-drawer .cart-item');
      if (hasItems) setTimeout(() => open(true), 450);
    });
  };
  hookDrawer();
  document.addEventListener('DOMContentLoaded', hookDrawer);
})();
